import { useAuth } from '../context/AuthContext';
import { useBilling } from '../context/BillingContext';

/**
 * Returns true for AMMINISTRATORE_AZIENDA and RESPONSABILE,
 * AND only when the tenant billing is write-allowed (R0.3).
 * OPERATORE is always read-only.
 */
export function useCanManage(): boolean {
  const { user } = useAuth();
  const { isWriteBlocked } = useBilling();
  return (
    !isWriteBlocked &&
    (user?.role === 'AMMINISTRATORE_AZIENDA' || user?.role === 'RESPONSABILE')
  );
}

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === 'AMMINISTRATORE_AZIENDA';
}
